<div class="dialog">
  <div class="dialog-header">
    <div class="dialog-header-left">
      <h2 mat-dialog-title>
        <i class="fa-light fa-user-pen header-button"></i>
        Member Update
      </h2>
    </div>
    <button mat-icon-button (click)="onCancelClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <mat-tab-group #tabGroup class="member-update-tab-group" (selectedIndexChange)="activeTabIndex = $event">
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label">
            <i class="fa-light fa-user-magnifying-glass"></i>
            Member Search
          </span>
        </ng-template>
        <div class="member-search-tab-content-container">
          <div class="dialog-form-container">
            <form class="memberSearchForm" [formGroup]="form" (ngSubmit)="onSearchSubmit()" novalidate>
              <!-- DMAP ID -->
              <mat-form-field appearance="fill">
                <mat-label>DMAP ID</mat-label>
                <input matInput
                       type="text"
                       formControlName="dmapIdFormControl"
                       maxlength="8" />
              </mat-form-field>

              <!-- Last Four of SSN -->
              <mat-form-field appearance="fill">
                <mat-label>Last Four of SSN</mat-label>
                <input matInput
                       type="number"
                       min="0"
                       formControlName="lastFourSsnFormControl"
                       maxlength="4" />
              </mat-form-field>

              <!-- Date of Birth -->
              <mat-form-field appearance="fill">
                <mat-label>Date of Birth</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="dobFormControl" />
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

              <!-- First Name -->
              <mat-form-field appearance="fill">
                <mat-label>First Name</mat-label>
                <input matInput
                       type="text"
                       formControlName="firstNameFormControl"
                       maxlength="35" />
                <mat-error *ngIf="form.get('firstNameFormControl').hasError('optionalMinLength')">
                  Must be at least 3 characters, if not empty.
                </mat-error>
              </mat-form-field>

              <!-- Last Name -->
              <mat-form-field appearance="fill">
                <mat-label>Last Name</mat-label>
                <input matInput
                       type="text"
                       formControlName="lastNameFormControl"
                       maxlength="60" />
                <mat-error *ngIf="form.get('lastNameFormControl').hasError('optionalMinLength')">
                  Must be at least 3 characters, if not empty.
                </mat-error>
              </mat-form-field>

              <!-- Member Phone Number -->
              <mat-form-field appearance="fill">
                <mat-label>Member Phone Number</mat-label>
                <input matInput
                       type="tel"
                       formControlName="phoneNumberFormControl"
                       maxlength="14"
                       placeholder="(XXX) XXX-XXXX"
                       (input)="formatPhoneNumber()"
                       (blur)="formatPhoneNumber()" />
              </mat-form-field>

              <!-- Search Button -->
              <div class="button-container">
                <button mat-raised-button
                        color="primary"
                        type="submit"
                        [disabled]="!form.valid">
                  <i class="fa-light fa-user-magnifying-glass"></i>
                  Search
                </button>
              </div>
            </form>

          </div>
          <div class="search-results-container">
            <p>Search Results: {{searchMemberResults.length}}</p>
            <div class="member-results-container">
              <div class="member-data-title">
                Members
              </div>
              <div class="member-data">
                <mat-table #table [dataSource]="searchMemberResultsDataSource" matSort (matSortChange)="onMemberGridSortChange($event)">
                  <!-- DMAP ID -->
                  <ng-container matColumnDef="DMAP">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="DMAP">DMAP</mat-header-cell>
                    <mat-cell *matCellDef="let member"> {{member.dmapId}} </mat-cell>
                  </ng-container>

                  <!-- First Name -->
                  <ng-container matColumnDef="FirstName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="FirstName">First Name</mat-header-cell>
                    <mat-cell *matCellDef="let member"> {{member.firstName}} </mat-cell>
                  </ng-container>

                  <!-- Last Name -->
                  <ng-container matColumnDef="LastName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="LastName">Last Name</mat-header-cell>
                    <mat-cell *matCellDef="let member"> {{member.lastName}} </mat-cell>
                  </ng-container>

                  <!-- DOB -->
                  <ng-container matColumnDef="DOB">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="DOB">DOB</mat-header-cell>
                    <mat-cell *matCellDef="let member"> {{member.dob | date:'MM/dd/yyyy'}} </mat-cell>
                    <mat-footer-cell *matFooterCellDef></mat-footer-cell>
                  </ng-container>

                  <!-- Phone Number -->
                  <ng-container matColumnDef="PhoneNumber">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="PhoneNumber">Phone Number</mat-header-cell>
                    <mat-cell *matCellDef="let member"> {{ member.phoneNumber | phoneNumber }} </mat-cell>
                  </ng-container>

                  <mat-header-row *matHeaderRowDef="searchMemberResultsDisplayColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: searchMemberResultsDisplayColumns;"
                           [ngClass]="{
                            'highlight': selectedMember?.dmapId == row.dmapId,
                            'clickable-row': selectedMember?.dmapId !== row.dmapId}"
                           (click)="loadMemberPlans(row)">
                  </mat-row>
                </mat-table>
              </div>
            </div>
            <div class="plan-results-container">
              <div class="member-plan-data-title">
                Member Plan History
              </div>
              <div class="member-plan-data">
                <mat-table #table [dataSource]="searchMemberPlansDataSource" matSort (matSortChange)="onPlansGridSortChange($event)">

                  <!-- Line Of Business -->
                  <ng-container matColumnDef="DCO">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="DCO">DCO</mat-header-cell>
                    <mat-cell *matCellDef="let plan"> {{ plan.rae }} </mat-cell>
                  </ng-container>

                  <!-- Description -->
                  <ng-container matColumnDef="Status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Status">Status</mat-header-cell>
                    <mat-cell *matCellDef="let plan"> {{ plan.enrollStatus }} </mat-cell>
                  </ng-container>

                  <!-- CCO Name -->
                  <ng-container matColumnDef="CCOName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="CCOName">CCO</mat-header-cell>
                    <mat-cell *matCellDef="let plan"> {{ plan.cco }} </mat-cell>
                  </ng-container>

                  <!-- Effective Date -->
                  <ng-container matColumnDef="StartDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="StartDate">Start Date</mat-header-cell>
                    <mat-cell *matCellDef="let plan"> {{ plan.effectiveDate | date:'MM/dd/yyyy' }} </mat-cell>
                  </ng-container>

                  <!-- End Date -->
                  <ng-container matColumnDef="EndDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="EndDate">End Date</mat-header-cell>
                    <mat-cell *matCellDef="let plan"> {{ plan.terminationDate | date:'MM/dd/yyyy' }} </mat-cell>
                  </ng-container>

                  <!-- Table Header Row -->
                  <mat-header-row *matHeaderRowDef="searchMemberPlansDisplayColumns"></mat-header-row>

                  <!-- Data Rows -->
                  <mat-row *matRowDef="let row; columns: searchMemberPlansDisplayColumns;" (click)="setMemberPlan(row)"></mat-row>

                </mat-table>
              </div>
            </div>
          </div>
        </div>


      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label">
            <i class="fa-light fa-pen-field"></i>
            Manual Update
          </span>

        </ng-template>

        <div class="manual-form-container">
          <form class="memberManualUpdateForm" [formGroup]="manualForm" (ngSubmit)="onSearchSubmit()" novalidate>
            <!-- DMAP ID -->
            <mat-form-field appearance="fill">
              <mat-label>DMAP ID</mat-label>
              <input matInput
                     type="text"
                     formControlName="manualDmapIdFormControl"
                     maxlength="8" />
            </mat-form-field>

            <!-- Date of Birth -->
            <mat-form-field appearance="fill">
              <mat-label>Date of Birth</mat-label>
              <input matInput [matDatepicker]="picker_manual" formControlName="manualDobFormControl" />
              <mat-datepicker-toggle matIconSuffix [for]="picker_manual"></mat-datepicker-toggle>
              <mat-datepicker #picker_manual></mat-datepicker>
            </mat-form-field>

            <!-- First Name -->
            <mat-form-field appearance="fill">
              <mat-label>First Name</mat-label>
              <input matInput
                     type="text"
                     formControlName="manualFirstNameFormControl"
                     maxlength="35" />
            </mat-form-field>

            <!-- Last Name -->
            <mat-form-field appearance="fill">
              <mat-label>Last Name</mat-label>
              <input matInput
                     type="text"
                     formControlName="manualLastNameFormControl"
                     maxlength="60" />
            </mat-form-field>

            <!-- Member Phone Number -->
            <mat-form-field appearance="fill">
              <mat-label>Member Phone Number</mat-label>
              <input matInput
                     type="tel"
                     formControlName="manualPhoneNumberFormControl"
                     maxlength="14"
                     placeholder="(XXX) XXX-XXXX"
                     (input)="formatManualPhoneNumber()"
                     (blur)="formatManualPhoneNumber()" />
            </mat-form-field>

          </form>

        </div>





      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="dialog-action-button-container">
      <button mat-flat-button class="btn btn-primary dialog-action-button" (click)="clearAllFields()"><i class="fa-light fa-arrows-rotate"></i>Reset</button>
      <button mat-flat-button class="btn btn-primary extended-action-button" (click)="onMemberSelectAndSend()" [disabled]="!membersActiveDCO"><i class="fa-light fa-share-from-square"></i>Save Member And Send to {{membersActiveDCO ? membersActiveDCO.rae : 'DCO'}}</button>
      <button mat-flat-button class="btn btn-primary dialog-action-button" (click)="onMemberSelect()"><i class="fa-light fa-floppy-disk"></i>Save Member</button>
    </div>
  </mat-dialog-actions>
</div>
